__turbopack_context__.v({
  "blok-big-title": "RadioFieldset-module__6tCSwG__blok-big-title",
  "blok-subtitle": "RadioFieldset-module__6tCSwG__blok-subtitle",
  "blok-title": "RadioFieldset-module__6tCSwG__blok-title",
  "disabled": "RadioFieldset-module__6tCSwG__disabled",
  "fieldset": "RadioFieldset-module__6tCSwG__fieldset",
  "fieldset-large": "RadioFieldset-module__6tCSwG__fieldset-large",
  "legend": "RadioFieldset-module__6tCSwG__legend",
  "radio-buttons": "RadioFieldset-module__6tCSwG__radio-buttons",
});
